/* LATTICE funnel 11 Oct 2026 · deferred, no deps. See snippets/lattice-funnel.liquid */
(function () {
  'use strict';
  var d = document, w = window, $ = function (s, r) { return (r || d).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var tpl = (d.getElementById('LatFunnelJs') || {}).dataset ? d.getElementById('LatFunnelJs').dataset.template : '';
  var P = null; try { var pj = d.getElementById('LatFunnelProduct'); if (pj) P = JSON.parse(pj.textContent); } catch (e) {}
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* privacy bar offset: keep fixed bottom UI above Shopify's consent banner */
  function bb() {
    var b = d.getElementById('shopify-pc__banner'), h = 0;
    if (b) { var r = b.getBoundingClientRect(), cs = getComputedStyle(b); if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < innerHeight) h = Math.max(0, innerHeight - r.top); }
    d.documentElement.style.setProperty('--lat-bb', Math.round(h) + 'px');
  }
  bb(); w.addEventListener('load', function () { bb(); setTimeout(bb, 2500); }); d.addEventListener('click', function () { setTimeout(bb, 400); }, true); w.addEventListener('resize', bb);

  /* 6b · plain collection links -> best-selling unless a sort is chosen (theme-only; admin sort orders untouched) */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^\/]+\/?$/i.test(u.pathname) || u.search) return;
    u.searchParams.set('sort_by', 'best-selling'); a.href = u.pathname + u.search + u.hash;
  }, true);

  /* product page: 1 sticky ATC, 3 size required, 8 record view */
  if (P) {
    var MF = 'product-form form[action*="/cart/add"]';
    var getForm = function () { return $('.product__info-container ' + MF) || $(MF); };
    var getBtn = function () { var f = getForm(); return f ? $('button[type=submit][name=add]', f) : null; };
    var btn = getBtn();
    var cur = function () { var f = getForm(), idIn = f && $('input[name=id]', f), id = idIn ? +idIn.value : 0; for (var i = 0; i < P.variants.length; i++) if (P.variants[i].id === id) return P.variants[i]; return P.variants[0]; };

    /* 3 · size required */
    var sizeFs = null;
    $$('variant-selects fieldset, variant-radios fieldset').forEach(function (fs) { var l = $('legend', fs); if (l && /^\s*size\b/i.test(l.textContent)) sizeFs = fs; });
    var chosen = !P.sizeRequired || !sizeFs || /[?&]variant=/.test(location.search);
    var msg = null;
    if (sizeFs) {
      msg = d.createElement('p'); msg.className = 'lat-size-msg'; msg.id = 'LatSizeMsg'; msg.setAttribute('role', 'alert'); msg.hidden = true;
      sizeFs.insertAdjacentElement('afterend', msg);
      if (!chosen) sizeFs.classList.add('lat-size-need');
      var pick = function () { chosen = true; sizeFs.classList.remove('lat-size-need', 'lat-size-err'); msg.hidden = true; setTimeout(sync, 350); };
      var isSize = function (t) { var fs = t.closest && t.closest('fieldset'), l = fs && $('legend', fs); return !!(l && /^\s*size\b/i.test(l.textContent) && fs.closest('variant-selects, variant-radios')); };
      d.addEventListener('change', function (e) { if (isSize(e.target)) pick(); else if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 350); });
      d.addEventListener('click', function (e) { var lab = e.target.closest && e.target.closest('label'); if (lab && isSize(lab)) pick(); });
    }
    function refind() { if (sizeFs && !sizeFs.isConnected) { $$('variant-selects fieldset').forEach(function (fs) { var l = $('legend', fs); if (l && /^\s*size\b/i.test(l.textContent)) sizeFs = fs; }); if (!chosen) sizeFs.classList.add('lat-size-need'); else sizeFs.classList.remove('lat-size-need'); if (msg && !msg.isConnected) sizeFs.insertAdjacentElement('afterend', msg); } }
    function needSize(text) {
      refind(); if (!sizeFs) return;
      msg.textContent = text; msg.hidden = false;
      sizeFs.classList.remove('lat-size-err'); void sizeFs.offsetWidth; sizeFs.classList.add('lat-size-err');
      sizeFs.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      var f = $('input:not([disabled])', sizeFs) || $('input', sizeFs); if (f) f.focus({ preventScroll: true });
    }
    d.addEventListener('submit', function (e) {
      if (!chosen && e.target === getForm()) { e.preventDefault(); e.stopImmediatePropagation(); needSize('Choose a size to add this to your cart.'); }
    }, true);
    var f0 = getForm(); if (f0) f0.addEventListener('submit', function (e) { if (!chosen) { e.preventDefault(); e.stopImmediatePropagation(); needSize('Choose a size to add this to your cart.'); } }, true);

    /* 1 · sticky ATC (mobile only via CSS) */
    var bar = null;
    if (btn) {
      bar = d.createElement('div'); bar.className = 'lat-satc'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Quick add to cart');
      bar.innerHTML = '<div class="lat-satc__info"><span class="lat-satc__t"></span><span class="lat-satc__m lat-mono"></span></div><button type="button" class="lat-satc__btn button button--primary"></button>';
      d.body.appendChild(bar);
      $('.lat-satc__t', bar).textContent = P.title.split(/ [–-] /)[0];
      $('.lat-satc__btn', bar).addEventListener('click', function () {
        if (!chosen) { needSize('Choose a size to add this to your cart.'); return; }
        var v = cur(); if (!v.available) { needSize('That size is sold out. Choose another size.'); return; }
        var cb = getBtn(); if (cb) cb.click();
      });
      var shown = false, setShown = function (on) { if (on === shown) return; shown = on; bar.classList.toggle('is-on', on); d.body.classList.toggle('lat-satc-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); $('.lat-satc__btn', bar).tabIndex = on ? 0 : -1; };
      setShown(false);
      var ticking = false, check = function () { ticking = false; var cb = getBtn(); if (!cb) return setShown(false); setShown(cb.getBoundingClientRect().bottom < 0); };
      w.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true }); check();
    }
    function sync() {
      refind();
      var v = cur();
      if (bar) {
        var b = $('.lat-satc__btn', bar), m = $('.lat-satc__m', bar);
        m.innerHTML = '<b>' + esc(v.price) + '</b>' + (P.variants.length > 1 ? ' · ' + esc(chosen ? v.title : v.title.replace(/\s*\/\s*[^\/]+$/, ' / pick size')) : '');
        b.textContent = v.available ? 'Add to cart' : 'Sold out'; b.setAttribute('aria-disabled', v.available ? 'false' : 'true');
      }
      if (msg) { if (chosen && !v.available) { msg.textContent = 'That size is sold out. Choose another size.'; msg.hidden = false; } else if (chosen) msg.hidden = true; }
    }
    sync();
    if (typeof w.subscribe === 'function' && w.PUB_SUB_EVENTS) w.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
    var mi = getForm() && $('input[name=id]', getForm()); if (mi) new MutationObserver(sync).observe(mi, { attributes: true, attributeFilter: ['value'] });

    /* 8 · record view */
    try {
      var k = 'lat_rv', L = JSON.parse(localStorage.getItem(k) || '[]').filter(function (x) { return x && x.h !== P.handle; });
      L.unshift({ h: P.handle, t: P.title, u: P.url, i: P.img, p: P.price }); localStorage.setItem(k, JSON.stringify(L.slice(0, 9)));
    } catch (e) {}
  }

  /* 8 · recently viewed row on product + cart pages */
  if (tpl === 'product' || tpl === 'cart') {
    var L2 = []; try { L2 = JSON.parse(localStorage.getItem('lat_rv') || '[]'); } catch (e) {}
    L2 = L2.filter(function (x) { return x && x.u && (!P || x.h !== P.handle); }).slice(0, 8);
    if (L2.length) {
      var s = d.createElement('section'); s.className = 'lat-rv page-width'; s.setAttribute('aria-labelledby', 'LatRvH');
      s.innerHTML = '<h2 class="lat-rv__h lat-mono" id="LatRvH">Recently viewed</h2><ul class="lat-rv__list" role="list">' + L2.map(function (x) {
        var name = String(x.t).split(/ [–-] /)[0];
        return '<li><a class="lat-rv__a" href="' + esc(x.u) + '">' + (x.i ? '<img class="lat-rv__img" src="' + esc(x.i) + '" width="360" height="360" loading="lazy" decoding="async" alt="">' : '<span class="lat-rv__img"></span>') + '<span class="lat-rv__t">' + esc(name) + '</span><span class="lat-rv__p lat-mono">' + esc(x.p) + '</span></a></li>';
      }).join('') + '</ul>';
      var main = d.getElementById('MainContent'); if (main) main.appendChild(s);
    }
  }

  /* 2 · cart drawer quick-add (cross-sell) */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lat-quickadd]'); if (!b) return;
    e.preventDefault(); var box = b.closest('.lat-xsell'), err = box && $('.lat-xsell__err', box);
    b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding…';
    var drawer = d.querySelector('cart-drawer');
    fetch((w.routes && w.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.latQuickadd, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function (j) {
        if (drawer && drawer.renderContents && j.sections) { drawer.renderContents({ id: j.items && j.items[0] && j.items[0].id, sections: j.sections }); }
        else location.href = (w.routes && w.routes.cart_url) || '/cart';
        var live = d.getElementById('CartDrawer-LiveRegionText'); if (live) live.textContent = 'Added to cart';
      })
      .catch(function (x) { b.removeAttribute('aria-busy'); b.textContent = '+ Add'; if (err) { err.textContent = x.message; err.hidden = false; } });
  });

  /* 6 · mobile 'Filter (N)' pill: pins to the bottom once the toolbar scrolls away */
  if (tpl === 'collection' || tpl === 'search') {
    var sum = $('.mobile-facets__open-wrapper');
    if (sum) {
      var wrap = sum.closest('menu-drawer') || sum.parentNode, on2 = false, t2 = false;
      var chk = function () {
        t2 = false; if (innerWidth >= 750) { if (on2) { on2 = false; sum.classList.remove('lat-filter-fab'); wrap.style.minHeight = ''; } return; }
        var r = wrap.getBoundingClientRect(), on = r.bottom < 0 && !sum.parentNode.open;
        if (on === on2) return; on2 = on;
        if (on) wrap.style.minHeight = r.height + 'px'; else wrap.style.minHeight = '';  /* no layout shift when the pill detaches */
        sum.classList.toggle('lat-filter-fab', on);
      };
      w.addEventListener('scroll', function () { if (!t2) { t2 = true; requestAnimationFrame(chk); } }, { passive: true }); chk();
    }
  }

  /* 7 · empty search -> suggestions (fetched once, on first focus) */
  var sug = null, loading = false;
  function showSug(input) {
    var host = input.closest('.search-modal__content') || input.closest('form').parentNode;
    if (!sug) {
      sug = d.createElement('div'); sug.className = 'lat-suggest'; sug.id = 'LatSuggest'; sug.hidden = true; sug.setAttribute('role', 'region'); sug.setAttribute('aria-label', 'Search suggestions');
      (input.closest('predictive-search, search-form') || input.closest('form')).appendChild(sug);
    } else if (!host.contains(sug)) (input.closest('predictive-search, search-form') || input.closest('form')).appendChild(sug);
    if (!sug.dataset.ok && !loading) {
      loading = true;
      fetch('/collections/all?sort_by=best-selling&section_id=lattice-search-suggest').then(function (r) { return r.text(); }).then(function (h) {
        var t = d.createElement('div'); t.innerHTML = h; var inner = t.querySelector('.lat-suggest__inner'); if (inner) { sug.appendChild(inner); sug.dataset.ok = 1; }
        loading = false; sug.hidden = !(input.value.trim() === '' && sug.dataset.ok);
      }).catch(function () { loading = false; });
    }
    sug.hidden = !(input.value.trim() === '' && sug.dataset.ok);
  }
  d.addEventListener('focusin', function (e) { var i = e.target; if (i.matches && i.matches('input[type=search][name=q]')) showSug(i); });
  d.addEventListener('input', function (e) { var i = e.target; if (sug && i.matches && i.matches('input[type=search][name=q]')) sug.hidden = !(i.value.trim() === '' && sug.dataset.ok); });
})();
